/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from '@azure/msal-browser';
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: window.env?.NX_MICROSOFT_CLIENT_ID|| process.env.NX_MICROSOFT_CLIENT_ID || "4500eb19-5531-4175-9236-e0583360cd88", // This is the ONLY mandatory field that you need to supply.
    // authority: 'https://login.microsoftonline.com/common', // Defaults to "https://login.microsoftonline.com/common"
    authority: `https://login.microsoftonline.com/${window.env?.NX_TENANT_ID || process.env.NX_TENANT_ID || "f01e930a-b52e-42b1-b70f-a8882b5d043b"}`,
    knownAuthorities: [],
    cloudDiscoveryMetadata: '',
    redirectUri: '/login', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [`${window.env?.NX_AZURE_API_SCOPE || process.env.NX_AZURE_API_SCOPE}`],
  forceRefresh: true, // Set this to "true" to skip a cached token and go to the server to get a new token
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
  scopes: ['openid', 'profile'],
  loginHint: 'example@domain.net',
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const tokenRequest = {
  scopes: ['User.Read', 'Mail.Read'],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};
